import { Fragment } from 'react'
// Styled
import { styled } from '@mui/material/styles'
// Components
import {
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from '@mui/material'
import { nothing } from '$helper/functions/utils'

export const SettingsIntendedDivider = styled(Divider)`
  margin-right: 20px;

  &:last-child {
    display: none;
  }
`

const StyledListItemButton = styled(ListItemButton)`
  min-height: 50px;

  box-sizing: border-box;
  padding: 0 20px 0 20px;
`

interface Props {
  text: string
  secondaryContent: JSX.Element
  onClick: () => any
}

export function SettingsItem({
  text,
  secondaryContent,
  onClick = nothing,
}: Props) {
  return (
    <Fragment>
      <ListItem disablePadding>
        <StyledListItemButton onClick={onClick}>
          <ListItemText
            primary={<Typography variant="body2">{text}</Typography>}
          />

          {secondaryContent || null}
        </StyledListItemButton>
      </ListItem>
      <SettingsIntendedDivider />
    </Fragment>
  )
}
